<template>
	<div>
		<aeg-case-home
			:caseViews="caseViews"
			addProposalButtonText="Add Jewellers Block Proposal"
			productTypeLabel="Type"
			selectProductInsuranceType="jewellers_block"
			:offerHasMultipleLayers="true"
		></aeg-case-home>
	</div>
</template>

<script>
import AegCaseHome from "./AegCaseHome"

export default {
	components: {
		AegCaseHome
	},
	data() {
		return {
			caseViews: {
				default_view: "AegCaseJewellersBlock"
			}
		}
	}
}
</script>
